__turbopack_context__.v({
  "indeed__content-wrapper": "page-module-scss-module__MRI32G__indeed__content-wrapper",
  "indeed__header-container": "page-module-scss-module__MRI32G__indeed__header-container",
  "indeed__hero-container": "page-module-scss-module__MRI32G__indeed__hero-container",
  "indeed__main-container": "page-module-scss-module__MRI32G__indeed__main-container",
});
